import {
    AfterViewInit,
    Component,
    Input,
	Output,
    OnChanges,
    OnDestroy,
    OnInit,
	SimpleChanges,
	EventEmitter,
	ViewChild,
	ElementRef
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
declare var google: any;

@Component({
    selector: 'app-current-location',
    templateUrl: './current-location.component.html',
    styleUrls: ['./current-location.component.scss'],
})

export class CurrentLocationComponent
    implements OnInit, OnChanges, AfterViewInit, OnDestroy{

	@Input() mapRef : Observable<google.maps.Map>;
	@Output() zoomToCurrentLocationEvent = new EventEmitter();
	@ViewChild("zoomCurrentLocationContainer") zoomToButtonContainer : ElementRef;
	@ViewChild("zoomCurrentLocationBtn") zoomToButton : ElementRef;
	mapRefsubscrition : Subscription;

	ngOnInit() : void {
		this.mapRefsubscrition = this.mapRef.subscribe(map => {
			if(map && null != this.zoomToButtonContainer?.nativeElement)
			{
				map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(this.zoomToButtonContainer.nativeElement);
			}
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		
	}

	ngAfterViewInit(): void {
		
	}

	ngOnDestroy(): void {
		this.mapRefsubscrition && this.mapRefsubscrition.unsubscribe();
	}

	private createCurrentLocationControl() : void {

	}

	onZoomToClicked(event : MouseEvent) {
		this.zoomToCurrentLocationEvent.emit(event);
	}

}
